module.exports = __webpack_public_path__ + "static/vhs-04-efc6ac6040d44a8f1b04b8f1ddc48c1e.gif";